export default "__VITE_ASSET__37d3bd73__"